import { useSelector } from 'react-redux';
import { IStore } from 'store/interface';
import { getHotOffersIdentifiers } from '../../selector';

export const useHotOffersIdentifiers = () => ({
  identifiers: useSelector<IStore, string[]>(getHotOffersIdentifiers),
});
